import { SegmentLimitsTranslations } from '../CreateTrade/types';
import { FeesListTranslations } from '../Reusable/FeesList/FeesList';
import { getAppConfig } from '@bts-web/core-app-config';

export type TradeScreenTranslations = {
  eur: string;
  aed: string;
  subTotal: string;
  total: string;
  fees: string;
  grams: string;
  confirmBuy: string;
  confirmSell: string;
  inclSpread: string;
  inclFees: string;
  afterSpread: string;
  afterFees: string;
  afterFeesAtCurrentPrice?: string;
  afterSpreadAtCurrentPrice?: string;
  actionButtonText: string;
  actionButtonLoadingText: string;
  investingRiskToggle: string;
  stocksToggleNotAppropriate: string;
  errorTooHigh: string;
  stakeErrorTooHigh: string;
  errorTooLow: string;
  errorTradingNotPossibleTitle: string;
  errorAssetNotAvailableTitle: string;
  errorAssetNotAvailableSubtitle: string;
  errorTradingNotPossibleSubtitle: string;
  errorTradingNotPossibleLink: string;
  max: string;
  buy: string;
  buySymbol: string;
  sellSymbol: string;
  reviewOrder: string;
  shares: string;
  buyNow: string;
  transactionFailedNotificationTitle: string;
  transactionFailedNotificationDescription: string;
  transactionDeclinedNotificationTitle: string;
  transactionDeclinedNotificationDescription: string;
  actionButtonVerifyText?: string;
  verifyTradeInfo?: string;
  derivativeContract: string;
  prospectus: string;
  andConfirmThatIhaveReadAndUnderstoodThe: string;
  and: string;
  costTransparencyDocuments: string;
  costTransparencyTitle: string;
  riskWarningText1: string;
  riskWarningText2: string;
  kidDisclaimerPartOne: string;
  kidDisclaimerPartTwo: string;
  kidTitle: string;
  keyInformationDocument: string;
  investorInformationDocument: string;
  legalToggleLastPart: string;
  legalTogglePartOne: string;
  sell: string;
  sellNow: string;
  units: string;
  generalErrorMessageTitle: string;
  backToPortfolio: string;
  taxWithHeld: string;
  youReceive: string;
  aboutTaxTextLink?: string;
  cryptoTaxInfoText1: string;
  cryptoTaxInfoText2: string;
  cryptoTaxInfoTitle: string;
  taxSystemOfflineWarningSubtitle: string;
  taxSystemOfflineWarningTitle: string;
  payment_method: string;
  bank_transfer: string;
  minimum: string;
  savingsPlan: string;
  setUpSavingsPlanBoxTitle: string;
  setUpSavingsPlanBoxDescription: string;
  frequency: string;
  startsAt: string;
  MONTHLY: string;
  BIWEEKLY?: string;
  WEEKLY: string;
  DAILY?: string;
  ok: string;
  cancel: string;
  confirm: string;
  nextPayment: string;
  nextRecurrence: string;
  savingsPlanAcceptTermTitle: string;
  savingsPlanAcceptTermDescription: string;
  errorMessageDuplicateSavingsPlan: string;
  savingsPlanInfoLabel: string;
  taxDetails: string;
  readOnly: string;
  swap: string;
  paymentMethod: string;
  buyAmount: string;
  sellAmount: string;
  offerPrice: string;
  stockExchange: string;
  tradeFee: string;
  tradeFeeInclVAT: string;
  buyVolume: string;
  sellVolume: string;
  taxWitheld: string;
  approx: string;
  percentage100: string;
  percentage75: string;
  percentage50: string;
  percentage25: string;
  percentageMinus1: string;
  percentageMinus5: string;
  percentageMinus10: string;
  percentagePlus1: string;
  percentagePlus5: string;
  percentagePlus10: string;
  market: string;
  poweredByTenant: string;
  stake: string;
  unstake: string;
  staking: string;
  unstaking: string;
  available: string;
  buyAsset: string;
  stopOrder: string;
  buyStopTitle: string;
  sellStopTitle: string;
  targetPrice: string;
  startPushTan: string;
  authenticationRequiredTitle: string;
  marketClosedNotificationTitle: string;
  marketClosedNotificationDescription: string;
} & FeesListTranslations &
  TradeStatusScreenTranslations;

export type TradeStatusScreenTranslations = {
  taxWitheld: string;
  successBuySubtitle: string;
  successSellSubtitle: string;
  successScreenNowAvailable: string;
  successBuyTitle: string;
  successSaleTitle: string;
  failureTransactionTitle: string;
  okGoToPortfolio: string;
  transactionFailTitle: string;
  backToPortfolioButton: string;
  pendingSellPageTitle: string;
  pendingBuyPageTitle: string;
  goToPortfolio: string;
  poweredByBpfs: string;
  viewTransaction: string;
  viewDetails: string;
  swapSuccessTitle: string;
  swapSubmittedSubtitle: string;
  swapSubmittedTitle: string;
  swapFailedTitle: string;
  swapFailedSubtitle: string;
  stakeFailedTitle: string;
  stakeFailedSubtitle: string;
  sellScreenTaxNotFinalWarning: string;
  failCardText: string;
  areYouSureTradeCancel: string;
  noDontCancel: string;
  yesGoToPortfolio: string;
  stake: string;
  tryAgain: string;
  fiatTransferLoadingTitle: string;
  fiatTransferLoadingSubtitle: string;
  fiatTransferResumingTitle: string;
  fiatTransferResumingSubtitle: string;
  fiatTransferRedirectTitle: string;
  fiatTransferRedirectSubtitle: string;
  fiatTransferSuccessNotificationTitle: string;
  fiatTransferRedirectNotificationTitle: string;
  fiatTransferRedirectNotificationSubtitle: string;
  fiatTransferRejectedStatusDescription: string;
  fiatTransferRefundedStatusDescription: string;
  fiatTransferOfferExpiredStatusDescription: string;
  fiatTransferDepositFundsConsumedStatusDescription: string;
  fiatTransferOfferAcceptedDescription: string;
  fiatTransferFailedTitle: string;
  depositManualReviewTitle: string;
  depositManualReviewDescription: string;
};

const tradeScreenTranslations: TradeScreenTranslations = {
  buy: 'buy',
  buySymbol: 'buy_symbol',
  eur: 'eur_label',
  aed: 'aed_label',
  subTotal: 'subtotal',
  total: 'total',
  fees: 'fees',
  shares: 'shares',
  grams: 'grams',
  riskWarningText1: 'risk_warning_text_1',
  riskWarningText2: 'risk_warning_text_2',
  confirmBuy: 'confirm_buy',
  confirmSell: 'confirm_sell',
  reviewOrder: 'review_order',
  inclSpread: 'incl_spread',
  inclFees: 'incl_fees',
  afterSpread: 'after_spread',
  afterFees: 'after_fees',
  buyNow: 'buy_now_button',
  actionButtonText: 'confirm',
  actionButtonLoadingText: 'trade_cta_button_loading',
  poweredByBpfs: 'powered_by_bpfs',
  and: 'and',
  andConfirmThatIhaveReadAndUnderstoodThe:
    'and_confirm_that_I_have_read_and_understood_the',
  investingRiskToggle: 'investing_risk_toggle',
  stocksToggleNotAppropriate: 'stocks_toggle_not_appropriate_description',
  actionButtonVerifyText: 'buy_verify_button',
  verifyTradeInfo: 'buy_verify_info',
  market: 'market',
  errorTooHigh: 'inline_error_amount_too_high',
  stakeErrorTooHigh: 'stake_error_amount_too_high',
  errorTooLow: 'inline_error_amount_too_low',
  errorAssetNotAvailableTitle: 'info_toast_asset_unavailable_title',
  errorAssetNotAvailableSubtitle: 'info_toast_asset_unavailable_subtitle',
  errorTradingNotPossibleTitle:
    'info_toast_trading_for_asset_not_possible_title',
  errorTradingNotPossibleSubtitle:
    'info_toast_trading_for_asset_not_possible_subtitle',
  errorTradingNotPossibleLink: 'info_toast_trading_for_asset_not_possible_link',
  transactionFailedNotificationTitle: 'error_toast_transaction_failed_title',
  transactionFailedNotificationDescription:
    'error_toast_transaction_failed_subtitle',
  transactionDeclinedNotificationTitle:
    'error_toast_user_cancel_transaction_title',
  transactionDeclinedNotificationDescription:
    'error_toast_user_cancel_transaction_title',
  derivativeContract: 'derivative_contract',
  costTransparencyDocuments: 'cost_transparency_document',
  costTransparencyTitle: 'cost_transparency_title',
  prospectus: 'prospectus',
  investorInformationDocument: 'investor_information_document',
  keyInformationDocument: 'key_information_document',
  kidDisclaimerPartOne: 'kid_disclaimer_part_one',
  kidDisclaimerPartTwo: 'kid_disclaimer_part_two',
  kidTitle: 'key_information_document_title',
  legalTogglePartOne: 'I_agree_to_the',
  legalToggleLastPart: 'legal_toggle_last_part',
  max: 'Max',
  successBuySubtitle: 'success_buy_subtitle',
  successScreenNowAvailable: 'success_screen_now_available',
  successSellSubtitle: 'success_sale_subtitle',
  failureTransactionTitle: 'transaction_fail_title',
  backToPortfolio: 'back_to_portfolio_button',
  generalErrorMessageTitle: 'general_error_message_title',
  sell: 'sell',
  sellSymbol: 'sell_symbol',
  units: 'units',
  sellNow: 'sell_now_button',
  taxWithHeld: 'tax_withheld',
  youReceive: 'you_receive',
  aboutTaxTextLink: 'about_tax_text_link',
  cryptoTaxInfoText1: 'crypto_tax_info_text_line_1',
  cryptoTaxInfoText2: 'crypto_tax_info_text_line_2',
  cryptoTaxInfoTitle: 'crypto_tax_info_title',
  taxSystemOfflineWarningSubtitle: 'tax_system_offline_warning_subtitle',
  taxSystemOfflineWarningTitle: 'tax_system_offline_warning_title',
  successBuyTitle: 'success_buy_title',
  successSaleTitle: 'success_sale_title',
  okGoToPortfolio: 'ok_go_to_portfolio',
  transactionFailTitle: 'transaction_fail_title',
  backToPortfolioButton: 'back_to_portfolio_button',
  failCardText: 'general_error_message_title',
  pendingBuyPageTitle: 'pending_buy_title',
  pendingSellPageTitle: 'pending_sell_title',
  goToPortfolio: 'go_to_portfolio',
  sellScreenTaxNotFinalWarning: 'sell_screen_tax_not_final_warning',
  payment_method: 'payment_method',
  bank_transfer: 'bank_transfer',
  minimum: 'minimum',
  savingsPlan: 'savings_plan',
  setUpSavingsPlanBoxTitle: 'set_up_savings_plan_box_title',
  setUpSavingsPlanBoxDescription: 'set_up_savings_plan_box_description',
  frequency: 'frequency',
  startsAt: 'starts_at',
  MONTHLY: 'monthly',
  BIWEEKLY: 'biweekly',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  ok: 'ok',
  cancel: 'cancel',
  confirm: 'confirm',
  nextRecurrence: 'next_recurrence_@tenant',
  nextPayment: 'next_payment_@tenant',
  savingsPlanAcceptTermTitle: 'savings_plan_accept_term_title',
  savingsPlanAcceptTermDescription: 'savings_plan_accept_term_description',
  errorMessageDuplicateSavingsPlan: 'error_message_duplicate_savings_plan',
  priceGuarantee: 'price_guarantee',
  taxDetails: 'tax_details',
  feesIncluded: 'fees_included',
  paymentMethod: 'payment_method',
  buyAmount: 'buy_amount',
  sellAmount: 'sell_amount',
  offerPrice: 'offer_price',
  stockExchange: 'stock_exchange',
  tradeFee: 'trade_fee',
  tradeFeeInclVAT: 'trade_fee_incl_vat',
  offerFeesDescription: 'offer_fees_description',
  savingsPlanInfoLabel: 'savings_plan_info_label_@tenant',
  buyVolume: 'buyVolume',
  sellVolume: 'sellVolume',
  readOnly: 'user_role_modal_read_only_title',
  swap: 'swap',
  taxWitheld: 'tax_withheld',
  viewTransaction: 'view_transaction',
  viewDetails: 'view_details',
  swapSuccessTitle: 'swap_success_title',
  swapSubmittedSubtitle: 'swap_submitted_subtitle',
  swapSubmittedTitle: 'swap_submitted_title',
  swapFailedTitle: 'swap_failed_title',
  swapFailedSubtitle: 'swap_failed_subtitle',
  stakeFailedTitle: 'stake_failed_title',
  stakeFailedSubtitle: 'stake_failed_subtitle',
  areYouSureTradeCancel: 'are_you_sure_trade_cancel_@tenant',
  noDontCancel: 'no_dont_cancel',
  yesGoToPortfolio: 'yes_go_to_portfolio',
  approx: 'approx',
  percentage100: 'percentage_100',
  percentage75: 'percentage_75',
  percentage50: 'percentage_50',
  percentage25: 'percentage_25',
  percentageMinus1: 'percentage_minus_1',
  percentageMinus5: 'percentage_minus_5',
  percentageMinus10: 'percentage_minus_10',
  // TODO update translation keys when available
  percentagePlus1: '+1%',
  percentagePlus5: '+5%',
  percentagePlus10: '+10%',
  poweredByTenant: 'powered_by_@tenant',
  stake: 'stake',
  tryAgain: 'try_again',
  staking: 'staking',
  available: 'available',
  buyAsset: 'buy_asset',
  unstake: 'unstake',
  unstaking: 'unstaking',
  stopOrder: 'stop_order_@tenant',
  buyStopTitle: 'stop_order_buy_title_@tenant',
  sellStopTitle: 'stop_order_sell_title_@tenant',
  targetPrice: 'stop_order_target_price',
  startPushTan: 'start_push_tan',
  authenticationRequiredTitle: 'authentication_required_title',
  marketClosedNotificationTitle: 'market_closed_notification_title',
  marketClosedNotificationDescription: 'market_closed_notification_description',
  fiatTransferLoadingTitle: 'fiat_transfer_loading_title',
  fiatTransferLoadingSubtitle: 'fiat_transfer_loading_subtitle',
  fiatTransferResumingTitle: 'fiat_transfer_resuming_title',
  fiatTransferResumingSubtitle: 'fiat_transfer_resuming_subtitle',
  fiatTransferRedirectTitle: 'fiat_transfer_redirect_title',
  fiatTransferRedirectSubtitle: 'fiat_transfer_redirect_subtitle',
  fiatTransferSuccessNotificationTitle:
    'fiat_transfer_success_notification_title',
  fiatTransferRedirectNotificationTitle:
    'fiat_transfer_redirect_notification_title',
  fiatTransferRedirectNotificationSubtitle:
    'fiat_transfer_redirect_notification_subtitle',
  fiatTransferRejectedStatusDescription:
    'fiat_transfer_rejected_status_description',
  fiatTransferRefundedStatusDescription:
    'fiat_transfer_refunded_status_description',
  fiatTransferOfferExpiredStatusDescription:
    'fiat_transfer_offer_expired_status_description',
  fiatTransferDepositFundsConsumedStatusDescription:
    'fiat_transfer_deposit_funds_consumed_status_description',
  fiatTransferOfferAcceptedDescription:
    'fiat_transfer_offer_accepted_description',
  fiatTransferFailedTitle: 'fiat_transfer_failed_title',
  depositManualReviewTitle: 'fiat_deposit_manual_review_title',
  depositManualReviewDescription: 'fiat_deposit_manual_review_description',
};

const segmentLimitsTranslations: SegmentLimitsTranslations = {
  modalTitle: 'segment_limit_title',
  limitReached: 'limit_reached',
  normalLimitAvailable: 'normal_limit_available',
  zeroLimitAvailable: 'zero_limit_available',
  limitContinuation: 'limit_continuation',
  goToPortfolio: 'go_to_portfolio',
  tryAgain: 'try_again',
  sell: 'sell',
};

const { minimumCalendarDaysBeforeExecution = 4 } = getAppConfig();

export const getTradeTranslations = (
  transUtil: (param: string, options?: Record<string, unknown>) => string,
): TradeScreenTranslations => {
  return Object.entries(tradeScreenTranslations).reduce((ts, [key, value]) => {
    const transKey = key as keyof TradeScreenTranslations;

    switch (transKey) {
      case 'setUpSavingsPlanBoxDescription':
        ts[transKey] = transUtil(value, {
          min_calendar_days_before_execution:
            minimumCalendarDaysBeforeExecution,
        });

        break;

      default:
        ts[transKey] = transUtil(value);
    }

    return ts;
  }, {} as TradeScreenTranslations);
};

export const getSegmentLimitTranslations = (
  transUtil: (param: string) => string,
): SegmentLimitsTranslations => {
  return Object.entries(segmentLimitsTranslations).reduce(
    (ts, [key, value]) => {
      ts[key as keyof SegmentLimitsTranslations] = transUtil(value);

      return ts;
    },
    {} as SegmentLimitsTranslations,
  );
};
